import BigNumber from 'bignumber.js';

export const getPriceLimit = ({
  isLong,
  slippageValue,
  price,
}: {
  isLong: boolean;
  slippageValue: number;
  price: BigNumber;
}) => {
  const slippageImpact = isLong ? 1 + slippageValue : 1 - slippageValue;

  return price.multipliedBy(slippageImpact);
};
